import * as React from "react";

import { MyBagPresentationItem } from "../../model";

import { useMyBagPresentationModel } from "./my-bag-presentation-model-provider";

interface MyBagOutOfStockPresentationModelConsumerInterface {
  presentationOutOfStockItems: MyBagPresentationItem[];
}
const defaultValue =
  {} as unknown as MyBagOutOfStockPresentationModelConsumerInterface;
const MyBagOutOfStockPresentationModelContext =
  React.createContext(defaultValue);

export const MyBagOutOfStockPresentationModelProvider: React.FunctionComponent =
  (props) => {
    const { presentationMyBagItems } = useMyBagPresentationModel();

    const presentationOutOfStockItems: MyBagOutOfStockPresentationModelConsumerInterface["presentationOutOfStockItems"] =
      React.useMemo(() => {
        return presentationMyBagItems.filter(
          (item) => item.isUnavailable
        );
      }, [presentationMyBagItems]);

    const value: MyBagOutOfStockPresentationModelConsumerInterface =
      React.useMemo(
        () => ({
          presentationOutOfStockItems,
        }),
        [presentationOutOfStockItems]
      );
    return (
      <MyBagOutOfStockPresentationModelContext.Provider value={value}>
        {props.children || []}
      </MyBagOutOfStockPresentationModelContext.Provider>
    );
  };

export const useMyBagOutOfStockPresentationModel = () => {
  const context = React.useContext(MyBagOutOfStockPresentationModelContext);
  if (context === defaultValue) {
    throw new Error(
      "useMyBagOutOfStockPresentationModel must be used within a MyBagOutOfStockPresentationModelProvider"
    );
  }
  return context;
};
